/**
 * @generated SignedSource<<6026f5f0d3c2f7d1fb98b0f8724c7074>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerTabsVariant_sku">;
  readonly " $fragmentType": "PdpRespDealerDetails_sku";
};
export type PdpRespDealerDetails_sku$key = {
  readonly " $data"?: PdpRespDealerDetails_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "ab4c00aeb0b3710b542de9d539aac2ce";

export default node;
